import React, { useEffect, useState } from "react";
import { DefaultModalCommonProps } from "../CommentModal/CommentModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRow } from "../BlackListModal/BlackListModal";
import { ModalLabel } from "../CommentModal/TargetContainer";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { Input } from "../../../../Input/Input";
import { DeleteModalLabel } from "../CommentModal/CommentDeleteModal";
import { Textarea } from "../../../../Input/Textarea";
import Loader from "../../../../DefaultStyles/Loader";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import AlertModal from "../../../../Modal/AlertModal";

interface Props extends DefaultModalCommonProps {
  uid: number;
}

export default function BackAccountEditModal({
  closeEvent,
  confirmEvent,
  uid,
}: Props) {
  const [banknumber, setbanknumber] = useState("");
  const [bankname, setbankname] = useState("");
  const [reason, setReason] = useState("");
  const [alert, setAlert] = useState(false);
  const [execute, setExecute] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: execute ? `user/updatebank` : undefined,
    data: {
      uid,
      banknumber,
      bankname,
      reason,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      closeEvent();
      if (confirmEvent) {
        confirmEvent();
      }
      toast.success("계좌정보를 수정했습니다.");
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "계좌정보 수정에 실패했습니다.");
    }
  }, [error]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      confirmEvent={() => setAlert(true)}
      modalTitle="계좌정보 수정"
      isMediumModal={true}
      confirmDisabled={reason === ""}
    >
      <>
        <ModalRow>
          <ModalLabel>은행코드 입력</ModalLabel>
          <ModalLabel
            style={{ textDecorationLine: "underline" }}
            onClick={() =>
              window.open(
                "https://docs-pay.toss.im/guide/bank-code"
              )
            }
          >
            코드확인하기
          </ModalLabel>
          <ModalRowContentContainer>
            <Input
              placeholder="은행코드를 입력해주세요"
              value={bankname}
              onChange={(e) => setbankname(e.target.value)}
              type="number"
            />
          </ModalRowContentContainer>
        </ModalRow>
        <ModalRow>
          <ModalLabel>계좌번호 입력</ModalLabel>

          <ModalRowContentContainer>
            <Input
              placeholder="계좌번호를 입력해주세요"
              value={banknumber}
              onChange={(e) => setbanknumber(e.target.value)}
              type="number"
            />
          </ModalRowContentContainer>
        </ModalRow>

        <DeleteModalLabel>등록 사유</DeleteModalLabel>

        <Textarea
          placeholder="등록 사유 입력(100글자 이내)"
          onChange={(e) => setReason(e.target.value)}
          value={reason}
        />

        {alert && (
          <AlertModal
            title={"계좌정보를 수정하시겠습니까?"}
            cancelEvent={() => setAlert(false)}
            confirmEvent={() => setExecute(true)}
            btnColor="mint"
          />
        )}

        {loading && <Loader />}
      </>
    </DefaultModalLayout>
  );
}
